import React, { useState, useEffect } from 'react';
import Table from '@material-ui/core/Table';
import clsx from 'clsx';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';  // Importe o componente TextField
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { lighten, makeStyles } from '@material-ui/core/styles';
import { getReviews } from '../../api/reviewService';
import { useHistory } from 'react-router-dom'; // Importe a função do serviço

import { Grid, Icon, Toolbar } from '@material-ui/core';  // Importe o componente Grid
import { Paper } from '@material-ui/core';

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight: theme.palette.type === 'light'
    ? {
      color: theme.palette.secondary.main,
      backgroundColor: lighten(theme.palette.secondary.light, 0.85),
    }
    : {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.dark,
    },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected, handleNewButtonClick } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        <Typography variant="h6" id="tableTitle">
          Reviews
        </Typography>
      </div>
    </Toolbar>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  search: {
    margin: theme.spacing(1),
    width: '90%'
  }
}));

function ReviewTable() {
  const classes = useStyles();
  const [reviews, setReviews] = useState([]);  // Crie um estado para armazenar as mensagens
  const [loading, setLoading] = useState(true);  // Crie um estado para controlar o carregamento dos dados
  const [page, setPage] = useState(0);  // Crie um estado para controlar a página atual
  const [rowsPerPage, setRowsPerPage] = useState(10);  // Crie um estado para controlar o número de linhas por página
  const [stars, setStars] = useState(null);  // Crie um estado para a categoria
  const [recommend, setRecommend] = useState(null);  // Crie um estado para a subcategoria
  const [pendingStars, setPendingStars] = useState(null);  // Crie um estado para a categoria pendente
  const [pendingRecommend, setPendingRecommend] = useState(null);  // Crie um estado para a subcategoria pendente

  const handleStars = ({ target }) => setPendingStars(target.value);
  const handleRecommend = ({ target }) => setPendingRecommend(target.value);

  // Função para redirecionar o usuário para a outra tela
  // Função para redirecionar o usuário para a outra tela
  const handleNewButtonClick = () => {
    history.push('/review');
  };

  const fetchData = () => {
    setLoading(true);
    getReviews(stars, recommend, page, rowsPerPage)
      .then(data => {
        setReviews(data);  // Atualize o estado com os dados
        setLoading(false);  // Defina o estado de carregamento como false
      })
      .catch(error => {
        console.error('Error fetching reviews:', error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [stars, recommend, page, rowsPerPage]);

  // Função para lidar com a mudança de página
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchData();
  };

  // Função para lidar com a mudança no número de linhas por página
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    fetchData();
  };

  // Função para lidar com o clique no botão "Pesquisar"
  const handleSearchClick = () => {
    setStars(pendingStars);
    setRecommend(pendingRecommend);
    fetchData();
  };

  // Obtém o objeto de histórico de navegação
  const history = useHistory();

  if (loading) {
    return <p>Loading...</p>;  // Renderize um indicador de carregamento enquanto os dados estão sendo buscados
  }

  return (
    <div className={classes.root}>
      <Paper style={{ backgroundColor: 'white' }}>
        <EnhancedTableToolbar handleNewButtonClick={handleNewButtonClick} />

        <div className={classes.tableWrapper}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                label="Stars"
                className={classes.search}
                onChange={handleStars}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                label="Recommend"
                className={classes.search}
                onChange={handleRecommend}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button variant="contained" color="primary" onClick={handleSearchClick} className={classes.search}>
                Search
              </Button>
            </Grid>
          </Grid>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Stars</TableCell>
                <TableCell>Recommend</TableCell>
                <TableCell>Observations</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reviews.map(message => (
                <TableRow key={message.id}>
                  <TableCell>{message.stars}</TableCell>
                  <TableCell>{message.recommend}</TableCell>
                  <TableCell>{message.observations}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          component="div"
          count={reviews.length}
          page={page}
          onChangePage={handleChangePage}
          rowsPerPage={rowsPerPage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

export default ReviewTable;